export default {
    googleMaps: {
        places: {
            API_KEY: import.meta.env.REACT_APP_GOOGLE_MAPS_PLACES_API_KEY
        }
    }
};
